<template>
  <transition appear name="fade" mode="in-out">
    <section class="page">
      <router-link
        class="back"
        :to="{
          name: 'company-list',
          query: { type: 'Approved', p: 10, q: 1, s: '' },
        }"
      >
        <i class="fal fa-chevron-left"></i>
      </router-link>

      <div class="page-header">
        <div class="page-header-start">
          <h3 class="page-title">Company Setup {{ $route.params.staffID }}</h3>
        </div>
      </div>
      <div class="tabs-container">
        <div class="tabs">
          <div class="tabs-start">
            <router-link
              :to="{ name: 'company-information', ...$route.params.UserId }"
              class="tab"
              >Information</router-link
            >
            <router-link
              :to="{
                name: 'company-user',
                params: { UserId: $route.params.UserId },
              }"
              class="tab"
              >User</router-link
            >
            <!-- <router-link :to="{name: 'company-featured', ...$route.params.UserId}" class="tab">Company Featured</router-link> -->
            <router-link
              :to="{ name: 'company-activity', ...$route.params.UserId }"
              class="tab"
              >Activity Log</router-link
            >
          </div>
        </div>
      </div>

      <router-view></router-view>
    </section>
  </transition>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(100px);
}
</style>
